import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-service-practice',
  templateUrl: './dialog-service-practice.component.html',
  styleUrls: ['./dialog-service-practice.component.scss'],
})
export class DialogServicePracticeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
